import React, { Component } from 'react'

class ErrorBoundary extends Component {
    constructor(props) {
        super(props)
        this.state = {
            hasError: false
        }
    }

    componentDidCatch(error, info) {
        this.setState({
            hasError: true
        })
    }

    render() {
        if (this.state.hasError) {
            return <p className="error">Sorry, we couldn't prep your kit. Please try again (and be sure to choose a city)!</p>
        }
        return this.props.children
    }
}

export default ErrorBoundary


// WEBPACK FOOTER //
// ./src/components/ErrorBoundary.js